// src/pages/ContactUs.js
import React from 'react';
import './ContactUs.css'; // Import the CSS file

function ContactUs() {
  const createPhoneLink = (phoneNumber) => {
    const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
    return <a href={`tel:${cleanNumber}`}>{phoneNumber}</a>;
  };

  const createWhatsAppLink = (phoneNumber) => {
    const cleanNumber = phoneNumber.replace(/[^0-9+]/g, '');
    const formattedNumber = cleanNumber.startsWith('+') ? cleanNumber : `+91${cleanNumber}`;
    return (
      <a
        href={`https://wa.me/${formattedNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-link"
      >
        {phoneNumber} (WhatsApp)
      </a>
    );
  };

  // IMPORTANT: REPLACE THESE WITH YOUR ACTUAL GOOGLE MAPS EMBED SRC VALUES.
  const mainOfficeMapSrc = "https://www.google.com/maps/embed?pb=!1m19!1m12!1m3!1d59518.69570263109!2d79.03148433319107!3d21.19539705672784!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m4!3e6!4m0!4m1!2s55%20Faras%2C%20Zingabai%20Takli%2C%20Nagpur%2C%20Maharashtra%2C%20India!5e0!3m2!1sen!2sin!4v1747835810406!5m2!1sen!2sin"; // Replace with your main office map src
  const specialSchoolMapSrc = "https://www.google.com/maps/embed?pb=!1m26!1m12!1m3!1d29765.19640463153!2d79.07281572306388!3d21.16634050310086!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m11!3e6!4m3!3m2!1d21.1795312!2d79.075803!4m5!1s0x3bd4c7c5a592863d%3A0xec763b412abb799b!2s5426%2BHC2%20Disha%20Abhiyan-Lilatai%20Deshmukh%20Education%20Training%20and%20Rehabilitation%20Center%20for%20Mental%20Challenge%20Girls.Itwari%2CNagpur%2C%20Itwari%2C%20Nagpur%2C%20Maharashtra%20440002!3m2!1d21.1513954!2d79.111024!5e0!3m2!1sen!2sin!4v1747838440092!5m2!1sen!2sin"; // Replace with your special school map src
  const workshopCentreMapSrc = "https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d119099.07015876155!2d79.02254413714967!3d21.118707284516088!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bd4bf775b46c7b3%3A0x534aed3d080e779d!2sJawahar%20Nagar%20lane%20no%201%2C%20manwada%20road%2C%20beside%20jawahar%20sabhagruh%2C%20Nagpur!3m2!1d21.1187261!2d79.1049704!5e0!3m2!1sen!2sin!4v1747838363069!5m2!1sen!2sin"; // Replace with your workshop centre map src


  return (
    <div className="contact-us-page">

      {/* --- Hero Section --- */}
      <section className="contact-hero-section">
        <h1 className="contact-hero-heading">Connect With Us</h1>
        <p className="contact-hero-subheading">
          We're here to answer your questions and provide support.
        </p>
      </section>

      <div className="container">
        {/* --- Main Office Section --- */}
        <section className="contact-section main-office-section">
          <h2 className="contact-section-title">Main Office</h2>
          <div className="contact-details-grid">
            <div className="contact-card address-card">              
              <h3><i className="fas fa-map-marker-alt"></i> 55 Faras, Zingabai Takli, Nagpur, Maharashtra, India</h3>
              {/* Embedded Map */}
              {mainOfficeMapSrc && (
                <div className="map-container">
                  <iframe
                    src={mainOfficeMapSrc}
                    width="100%"
                    height="280"
                    style={{ border: 0 }}
                    allowFullScreen={true}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Main Office Location"
                  ></iframe>
                </div>
              )}
            </div>
            <div className="contact-card social-card">
              {/* <h3><i className="fas fa-share-alt"></i> Social Media</h3> */}
              {/* NEW: Wrapper for social icons to be side-by-side */}
              <div className="social-icons-horizontal">
                <a href="https://www.instagram.com/vssnagpur" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                  <i className="fab fa-instagram"></i> {/* No text here */}
                </a>
                <a href="https://www.facebook.com/YOUR_FACEBOOK_LINK" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                  <i className="fab fa-facebook-f"></i> {/* No text here */}
                </a>
                <a href="https://www.youtube.com/YOUR_YOUTUBE_LINK" target="_blank" rel="noopener noreferrer" className="social-icon youtube">
                  <i className="fab fa-youtube"></i> {/* No text here */}
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* --- Special School & Workshop Centre sections will be side-by-side on large/medium screens --- */}
        <div className="other-locations-grid"> {/* NEW: Wrapper for these two sections */}

            {/* --- Special School Section --- */}
            <section className="contact-section special-school-section">
            <h2 className="contact-section-title">Smt. Lilatai Deshmukh Residential Special School</h2>
            <div className="contact-details-grid">
                <div className="contact-card address-card">
                <h3><i className="fas fa-map-marker-alt"></i> Madanwada Itwari, In Front Of Datta Mandir, Nagpur</h3>
                
                    {/* Embedded Map */}
                    {specialSchoolMapSrc && (
                        <div className="map-container">
                        <iframe
                            src={specialSchoolMapSrc}
                            width="100%"
                            height="280"
                            style={{ border: 0 }}
                            allowFullScreen={true}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Special School Location"
                        ></iframe>
                        </div>
                    )}
                </div>
                <div className="contact-card phone-card">
                {/* <h3><i className="fas fa-phone"></i> Contact Numbers</h3> */}
                <p>{createPhoneLink('8888851101')}, {createPhoneLink('7020992018')}</p>
                {/* <p></p> */}
                <p>{createWhatsAppLink('8888851101')}</p>
                </div>
            </div>
            </section>

            {/* --- Workshop Centre Section --- */}
            <section className="contact-section workshop-centre-section">
            <h2 className="contact-section-title">Indutai Dhoble Workshop and Rehabilitation Centre</h2>
            <div className="contact-details-grid">
                <div className="contact-card address-card">
                <h3><i className="fas fa-map-marker-alt"></i> 292, Jawahar Nagar, Near Jawahar Sabhagruh, Nagpur. 440024</h3>
                {/* <p></p> */}
                {/* Embedded Map */}
                {workshopCentreMapSrc && (
                    <div className="map-container">
                    <iframe
                        src={workshopCentreMapSrc}
                        width="100%"
                        height="280"
                        style={{ border: 0 }}
                        allowFullScreen={true}
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Workshop Centre Location"
                    ></iframe>
                    </div>
                )}
                </div>
                <div className="contact-card phone-card">
                {/* <h3><i className="fas fa-phone"></i> Contact Numbers</h3> */}
                <p>{createPhoneLink('8793909183')}, {createPhoneLink('9404537177')}</p>
                {/* <p></p> */}
                <p>{createWhatsAppLink('8793909183')}</p>
                </div>
            </div>
            </section>

        </div> {/* End .other-locations-grid */}

      </div> {/* End .container */}
    </div>
  );
}

export default ContactUs;